import { createActionConst } from '../../../../utils/action.utils';

const USER_SETTINGS_NAMESPACE = 'USER_SETTINGS';

export const GET_USER_SETTINGS = createActionConst(USER_SETTINGS_NAMESPACE, 'GET_USER_SETTINGS');
export const STORE_USER_SETTINGS = createActionConst(USER_SETTINGS_NAMESPACE, 'STORE_USER_SETTINGS');
export const CLEAR_USER_SETTINGS = createActionConst(USER_SETTINGS_NAMESPACE, 'CLEAR_USER_SETTINGS');

export const UPDATE_USER_SETTINGS = createActionConst(USER_SETTINGS_NAMESPACE, 'UPDATE_USER_SETTINGS');

export const STORE_USER_WIDGETS = createActionConst(USER_SETTINGS_NAMESPACE, 'STORE_USER_WIDGETS');
export const STORE_USER_WIDGET_VISIBILITY = createActionConst(USER_SETTINGS_NAMESPACE, 'STORE_USER_WIDGETS');
export const REORDER_USER_WIDGETS = createActionConst(USER_SETTINGS_NAMESPACE, 'REORDER_USER_WIDGETS');
export const UPDATE_USER_WIDGET_SIZE = createActionConst(USER_SETTINGS_NAMESPACE, 'UPDATE_USER_WIDGET_SIZE');
